import { cssClass } from '../../../../style';

export namespace SharedViewsButtonStyle {
  export const sharedViewsButtonCssPrefix = 'SharedViewsButton';

  export const DropdownButton = cssClass(sharedViewsButtonCssPrefix, 'dropdown-button', {
    $nest: {
      '& [role="presentation"]': {
        display: 'none',
      },
      'button:hover:enabled': {
        backgroundColor: 'transparent',
        cursor: 'pointer',
      },
    },
  });

  export const Card = cssClass(sharedViewsButtonCssPrefix, 'card', {
    marginTop: '2px',
  });

  export const List = cssClass(sharedViewsButtonCssPrefix, 'list', {
    marginBottom: '3px',
    verticalAlign: 'middle',
  });

  export const ListContainer = cssClass(sharedViewsButtonCssPrefix, 'list-container', {
    width: 'fit-content',
  });
}